import { ReactNode } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import { PageHeaderStyled } from 'pages/automations/common/Common.styles';

interface MessageLogTabHeaderProps {
  children: ReactNode;
}

const MessageLogTabHeader = ({ children }: MessageLogTabHeaderProps) => {
  const { t } = useTranslation();

  return (
    <PageHeaderStyled
      title={t('pageAutomations.messageLog.title')}
      subtitle={
        <Trans
          i18nKey="pageAutomations.messageLog.subtitle"
          components={{
            link1: (
              <NavLink
                aria-label={t('pageAutomations.tabNames.message-log')}
                to="../scheduled-messages"
              />
            ),
          }}
        />
      }
      noDivider
    >
      <div className="child-container">{children}</div>
    </PageHeaderStyled>
  );
};

export default MessageLogTabHeader;
